import { useEffect, useRef, useState } from 'react';

import type React from 'react';

import { fieldError, setClass } from '../../helpers/utils';
import { Upload as IconUpload } from '../Icons/Upload';
import './styles.scss';

type InputFileProps = {
	className?: string;
	id?: string;
	name?: string;
	value?: string;
	placeholder?: string;
	disabled?: boolean;
	onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
	hookForm?: any;
};

export const InputFile = ({
	className = '',
	id,
	name,
	value,
	placeholder,
	disabled = false,
	onChange,
	hookForm = { formState: { errors: {} } } as any,
}: InputFileProps) => {
	const [isFill, setIsFill] = useState(false);
	const [fileText, setFileText] = useState('');
	const inputEl = useRef(null);

	const {
		register,
		watch,
		formState: { errors },
	} = hookForm;

	const watchInput = watch?.(name, true);

	const handleChange = (event) => {
		const elem = event.target;

		if (elem.files.length > 0) {
			setFileText(elem.files[0].name);
		} else {
			setFileText('');
		}

		if (typeof onChange === 'function') {
			onChange(event);
		}
	};

	const isEmptyValue = () => {
		const elem = inputEl.current;
		const input = elem.querySelector('input');
		return !(input.value.trim().length > 0);
	};

	// useEffect(() => {
	//   setIsFill(!isEmptyValue());
	// }, []);

	useEffect(() => {
		setIsFill(!isEmptyValue());
	}, [watchInput]);

	return (
		<div
			ref={inputEl}
			className={setClass(`input-file icon-right
        ${isFill ? 'is-fill' : ''}
        ${disabled ? 'is-disabled' : ''}
        ${fieldError(errors, name) ? 'is-error' : ''}
        ${className}`)}
		>
			<span className="placeholder">{placeholder}</span>
			<span className="filetext">{fileText}</span>
			<label>
				<input
					type="file"
					id={id}
					name={name}
					defaultValue={value}
					value={value}
					disabled={disabled}
					onChange={handleChange}
					{...register?.(name, {
						onChange: (e) => handleChange(e),
					})}
				/>
				<div>
					<IconUpload />
				</div>
			</label>

			{fieldError(errors, name) && (
				<span className="message-error">
					{(fieldError(errors, name) as any).message}
				</span>
			)}
		</div>
	);
};
